import repository from './repsitory'

const resource = '/order'

export default {
    get () { // active
        return repository.get(`${resource}`)
    },
    getForValidation () { // validate
        return repository.get(`${resource}/validate`)
    },
    getPreorders () {
        return repository.get(`${resource}/preorder`)
    },
    getProcess () { // process
        return repository.get(`${resource}/process`)
    },
    getDeliver () { // deliver
        return repository.get(`${resource}/deliver`)
    },
    getRevoke () { // revoke
        return repository.get(`${resource}/revoked`)
    },
    getCancel () { // cancel
        return repository.get(`${resource}/cancel`)
    },
    getById (id) {
        return repository.get(`${resource}/${id}`)
    },
    getXmlResponse (id) {
        return repository.get(`${resource}/response/${id}`)
    },
    getXmlSigned (id) {
        return repository.get(`${resource}/sign/${id}`)
    },
    getPdfInvoice (id) {
        return repository.get(`${resource}/invoice/${id}`)
    },
    addOrder (data) {
        return repository.post(`${resource}`, data)
    },
    updateOrder (data, id) {
        return repository.put(`${resource}/${id}`, data)
    },
    createCreditNote (id) {
        return repository.get(`${resource}/revoke/${id}`)
    },
}
